import { AppLayoutToolbar, Box, SplitPanel } from '@cloudscape-design/components';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSplitPanel } from 'src/context/SplitPanelContext';
import AppRouter from 'src/AppRouter';
import AppBreadcrumbs from './AppBreadcrumbs';
import CustomSideNavigation from './CustomSideNavigation';
import { useUserPreferences } from 'src/store/userPreferences/useUserPreferences';
import { ROUTE_RISK_ENGINE, ROUTE_RISK_ENGINE_DETAIL } from 'src/v2/routes';

export type AppLayoutContentType = 'form' | 'table';

export function resolveAppLayoutContentType(pathname: string): AppLayoutContentType {
  // Both the Risk Engine list and its per-station breakdown are wide, data-dense tables, so they
  // use the full-width 'table' content type rather than the centered 'form' width.
  return pathname === ROUTE_RISK_ENGINE || pathname === ROUTE_RISK_ENGINE_DETAIL
    ? 'table'
    : 'form';
}

const AppLayoutWrapper = () => {
  const { pathname } = useLocation();
  const { content, title, closeView, panelSize, setPanelSize } = useSplitPanel();
  const { userPreferences } = useUserPreferences();
  const hasNoPreferences = !userPreferences?.profileSettings?.businessUnit;
  const [navigationOpen, setNavigationOpen] = useState(true);
  const [splitPanelPreferences, setSplitPanelPreferences] = useState<any>({
    position: 'side',
  });
  const contentType = resolveAppLayoutContentType(pathname);

  return (
    <AppLayoutToolbar
      data-testid="app-layout-toolbar"
      headerSelector={'#topnav'}
      splitPanelOpen={content != null}
      onSplitPanelToggle={() => closeView()}
      contentType={contentType}
      splitPanelPreferences={splitPanelPreferences}
      onSplitPanelPreferencesChange={({ detail }) => setSplitPanelPreferences(detail)}
      splitPanelSize={panelSize}
      disableContentPaddings={true}
      splitPanel={
        <SplitPanel data-testid="split-panel" hidePreferencesButton={true} header={title}>
          {content}
        </SplitPanel>
      }
      toolsHide={true}
      onSplitPanelResize={(size) => {
        setPanelSize(size.detail.size);
      }}
      breadcrumbs={<AppBreadcrumbs />}
      navigationOpen={navigationOpen && !hasNoPreferences}
      onNavigationChange={({ detail }) =>
        !hasNoPreferences && setNavigationOpen(detail.open)
      }
      navigation={!hasNoPreferences ? <CustomSideNavigation /> : undefined}
      navigationHide={hasNoPreferences}
      content={
        <Box
          data-testid="content-box"
          padding={{ left: 'l', right: 'l', top: 's', bottom: 's' }}
        >
          <AppRouter />
        </Box>
      }
    />
  );
};

export default AppLayoutWrapper;
